import { render, staticRenderFns } from "./PaquetesPrecioForm.vue?vue&type=template&id=c3ed6e06&scoped=true"
import script from "./PaquetesPrecioForm.vue?vue&type=script&lang=js"
export * from "./PaquetesPrecioForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ed6e06",
  null
  
)

export default component.exports